import { User } from '../../types/user'
import { LeasingContext } from '../../types/leasingContext'
import {
    UserActionTypes,
    SET_ROOT_USER,
    SET_LEASE_ID,
    SET_LEASING_CONTEXT,
} from './types'
import { ThunkAction } from 'redux-thunk'
import { RootState } from '..'
import { axiosInstance } from '../../helpers/axios'

export const setRootUser = (user?: User): UserActionTypes => ({
    type: SET_ROOT_USER,
    user,
})

export const setLeaseId = (id?: number): UserActionTypes => ({
    type: SET_LEASE_ID,
    leaseId: id,
})

export const setLeasingContext = (
    leasingContext?: LeasingContext | null,
): UserActionTypes => ({
    type: SET_LEASING_CONTEXT,
    leasingContext,
})

export const fetchLeasingContext = (): ThunkAction<
    Promise<LeasingContext | null>,
    RootState,
    unknown,
    UserActionTypes
> => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.get('user/leasing-context/')
            dispatch(setLeasingContext(response.data))
            return response.data
        } catch {
            dispatch(setLeasingContext(null))
            return null
        }
    }
}

export const selectPortalMembership = (
    apartmentId: string,
): ThunkAction<
    Promise<LeasingContext | null>,
    RootState,
    unknown,
    UserActionTypes
> => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.patch('user/leasing-context/', {
                apartment_id: apartmentId,
            })
            dispatch(setLeasingContext(response.data))
            return response.data
        } catch {
            return null
        }
    }
}

export const claimPendingInvite = (
    inviteToken: string,
): ThunkAction<
    Promise<LeasingContext>,
    RootState,
    unknown,
    UserActionTypes
> => {
    return async (dispatch) => {
        const response = await axiosInstance.post<LeasingContext>(
            `outreach/lead-invitations/${inviteToken}/claim/`,
        )
        dispatch(setLeasingContext(response.data))
        return response.data
    }
}
